import scrolling from './scrolling';

const imagesLoaded = require('imagesloaded');
const picturefill = require('picturefill');

/*
listens to images bing loaded with imagesloaded, and makes images fade in nicely
*/

const images = (() => {
  const CLASSNAME_LOADING = 'is-loading';
  const DOT = '.';
  const SELECTOR_LOADING = DOT + CLASSNAME_LOADING;

  let imagesToLoad;

  function onImageLoad() {
    this.classList.remove(CLASSNAME_LOADING);
    scrolling.rebuildCache();
  }

  function init() {
    // elements to picturefill
    const elements = document.querySelectorAll('.content picture img');

    if (elements && elements.length) {
      picturefill({
        elements,
      });
    }

    // images to fade-in after load
    imagesToLoad = document.querySelectorAll(SELECTOR_LOADING);

    if (!imagesToLoad || !imagesToLoad.length) {
      return;
    }
    [].forEach.call(imagesToLoad, (image) => {
      imagesLoaded(image, onImageLoad.bind(image));
    });
  }
  return {
    init,
  };
})();
export default images;
